/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as DataServiceEntities from './DataServiceEntities.g';

import { mWPProcessSYCORCustomerAsync } from './DataActionExtension.g';
/**
 * ProcessSycorCustomer Input Action
 */
export class ProcessSycorCustomerInput implements Msdyn365.IActionInput {
    public readonly processSycorEntity?: DataServiceEntities.IMWPSYCOREntity;

    constructor(processSycorEntity: DataServiceEntities.IMWPSYCOREntity) {
        this.processSycorEntity = processSycorEntity;
    }

    public getCacheKey = () => `SYCOR`;
    public getCacheObjectType = () => 'SYCOR';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

/**
 * Validates the user's authentication and returns `createProcessSycorInput`
 * @throws Error if the user is not authenticated
 */
const createProcessSycorInput = (
    user: Msdyn365.ICreateActionContext<Msdyn365.IGeneric<Msdyn365.IAny>>,
    inputData: DataServiceEntities.IMWPSYCOREntity
): Msdyn365.IActionInput => {
    if (!user.requestContext.user.isAuthenticated) {
        throw new Error('Unable to fulfill request. User is not authenticated.');
    }
    return new ProcessSycorCustomerInput(inputData);
};

export async function tasProccessSycorCustomer(
    input: ProcessSycorCustomerInput,
    ctx: Msdyn365.IActionContext
): Promise<DataServiceEntities.IMWPSYCORResponse> {
    const entity = input.processSycorEntity;
    if (!entity) {
        return Promise.reject('Input data not provided');
    }
    const res = await mWPProcessSYCORCustomerAsync({ callerContext: ctx, bypassCache: 'getAndPut' }, entity);
    return res;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<DataServiceEntities.IMWPSYCORResponse>>tasProccessSycorCustomer,
    id: 'ProcessSycorCustomer',
    input: createProcessSycorInput
});
